// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__vamoe","row":"Node_row__2qMan","label":"Node_label__2T_Ir","footer":"Node_footer__maUZT"};